// 관리자 섹션 본문에 쓰는 간단한 인라인 마크업을 React 노드로 변환한다.
// **텍스트** → 굵게, ++텍스트++ → 크게 (AdminProjectFormPage의 "선택한 텍스트만" 버튼이 삽입하는 마커)
const INLINE_MARKUP = /\*\*([\s\S]+?)\*\*|\+\+([\s\S]+?)\+\+/g;

export function renderFormattedText(text) {
  if (!text) return text;

  const nodes = [];
  let lastIndex = 0;
  let key = 0;
  let match;

  INLINE_MARKUP.lastIndex = 0;
  while ((match = INLINE_MARKUP.exec(text)) !== null) {
    if (match.index > lastIndex) nodes.push(text.slice(lastIndex, match.index));
    if (match[1] !== undefined) {
      nodes.push(<strong key={key++}>{match[1]}</strong>);
    } else {
      nodes.push(<span key={key++} style={{ fontSize: '1.3em' }}>{match[2]}</span>);
    }
    lastIndex = INLINE_MARKUP.lastIndex;
  }
  if (lastIndex < text.length) nodes.push(text.slice(lastIndex));

  return nodes;
}

// 섹션 전체 크기/굵기 설정 — 관리자에서 고른 값이 기본값(md/regular)이면
// 기존 CSS(반응형 브레이크포인트 포함)를 그대로 두고, 바꾼 경우에만 override한다.
export const TEXT_SIZE_PX = { sm: '12px', md: '14px', lg: '18px' };
export const TEXT_WEIGHT   = { regular: 400, bold: 700 };

export function sectionTextStyle(sec) {
  const style = {};
  if (sec?.textSize && sec.textSize !== 'md') style.fontSize = TEXT_SIZE_PX[sec.textSize];
  if (sec?.textWeight && sec.textWeight !== 'regular') style.fontWeight = TEXT_WEIGHT[sec.textWeight];
  return style;
}
